import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColDef, RowNode, SideBarDef } from 'ag-grid-community';
import { CommonService } from 'app/service/common.service';
import { CustomMessages } from '../custom-messages/custom-messages';

import { AgGridAngular } from 'ag-grid-angular';
import { AgGridModule } from 'ag-grid-angular';
import 'ag-grid-enterprise';

import { CellClickedEvent, GridReadyEvent, RowGroupingDisplayType } from 'ag-grid-community';
import { AuditorBenchAuditDetailScopeDetailDTO } from 'app/model/auditor-bench-audit-detail-scope-detail-dto';
import { AuditDetailsService } from 'app/service/audit-details.service';
import { Router } from '@angular/router';
import { ButtonRendererComponent } from './button-renderer.component';
import { ReloadService } from 'app/service/reload.service';

@Component({
  selector: 'app-ag-grid-remark',
  templateUrl: './ag-grid-remark.component.html',
  styleUrls: ['./ag-grid-remark.component.scss'],
  entryComponents: [ButtonRendererComponent],
})
export class AgGridRemarkComponent implements OnInit {
  frameworkComponents: any;
  context: any;
  private gridApi: any;
  constructor(
    private commonService: CommonService,
    private route: Router,
    private auditDetailsService: AuditDetailsService,
    private datePipe: DatePipe,
    private reloadserv: ReloadService,
    private customMessage: CustomMessages,
    private http: HttpClient
  ) {
    this.reloadserv.reload$.subscribe(() => {
      this.getRemarksHistoryList();
    });
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
    };
    this.context = { componentParent: this };
  }
  @Input() scopeDetailDTO: any | undefined;
  @Input() closePanelattachments: any | undefined;
  @Input() setReadOnly: any | undefined;
  //@Input() reload: boolean;
  @Output() reload = new EventEmitter<void>();
  data: any[];
  auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO = new AuditorBenchAuditDetailScopeDetailDTO();
  // Each Column Definition results in one Column.

  // ngOnChanges() {
  //   if (this.reload) {
  //     this.getRemarksHistoryList();
  //   }
  // }

  ngOnInit() {
    this.reloadData();
    this.auditorBenchAuditDetailScopeDetailDTO.scopeId = this.scopeDetailDTO.scopeId;
    this.value1 = this.scopeDetailDTO.scopeId;
    this.getRemarksHistoryList();
  }
  reloadData() {
    this.reload.emit();
  }

  value1: any = '';
  public columnDefs: ColDef[] = [
    {
      headerName: '#',
      field: 'Sno',
      width: 48,
      valueGetter: 'node.rowIndex + 1',
      tooltipField: 'Sno',
      suppressMenu: true,
    },
    {
      headerName: 'Actions',
      field: 'Actions',
      cellRenderer: 'buttonRenderer',
      width: 75,
      suppressMenu: true,
    },
    {
      headerName: 'Remarks',
      field: 'gvRemarks',
      tooltipField: 'gvRemarks',
      autoHeight: true,
      suppressMenu: true,
      width: 565,
      cellStyle: { 'white-space': 'normal', 'line-height': 1.5 },
      cellClass: 'cell-wrap',
    },
    { headerName: 'Created By', field: 'gvCreatedBy', suppressMenu: true },
    { headerName: 'Created On', field: 'gvCreatedOn', width: 147, suppressMenu: true },
    { headerName: 'ReadOnly', field: 'isReadOnly', width: 135, suppressMenu: true, hide: true },
  ];

  // DefaultColDef sets props common to all Columns
  public rowHeight = 30;
  public defaultColDef: ColDef = {
    // sortable: true,
    //filter: false,
    //floatingFilter: false,
    resizable: true,
    // enableValue: true,
    //defaultAggFunc: 'count',
    wrapText: true,
    cellStyle: { 'border-right': '1px solid #babfc7' },
  };
  // public sideBar: SideBarDef | string | string[] | boolean | null = 'columns';
  public groupDefaultExpanded = 1;
  // public groupDisplayType: RowGroupingDisplayType = 'multipleColumns';
  public rowGroupPanelShow = 'always';
  public pivotPanelShow = 'always';

  // Data that gets displayed in the grid
  public rowData: any[];
  value: Object;
  selectedVType: any;
  parsedJson: any;

  // Example of consuming Grid Event
  onCellClicked(e: CellClickedEvent): void { }

  onDeleteClick(node: RowNode) {
    this.gridApi.updateRowData({ remove: [node.data] });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.api.resetRowHeights();
    // this.gridApi.setHeaderHeight(40);
  }

  // headerHeightSetter() {
  //   var padding = 20;
  //   var height = headerHeightGetter() + padding;
  //   this.gridApi.setHeaderHeight(height);
  //   this.gridApi.resetRowHeights();
  // }

  // headerHeightGetter() {
  //   var columnHeaderTexts = document.querySelectorAll('.ag-header-cell-text');

  //   var columnHeaderTextsArray = [];

  //   columnHeaderTexts.forEach(node => columnHeaderTextsArray.push(node));

  //   var clientHeights = columnHeaderTextsArray.map(
  //     headerText => headerText.clientHeight
  //   );
  //   var tallestHeaderTextHeight = Math.max(clientHeights);
  //   return tallestHeaderTextHeight;
  // }

  getRemarksHistoryList() {
    this.auditDetailsService.getRemarksList(this.auditorBenchAuditDetailScopeDetailDTO).subscribe(
      data => {
        // this.parsedJson = JSON.parse(JSON.stringify(data));
        let parsedJson: any;
        parsedJson = JSON.parse(JSON.stringify(data));
        this.data = parsedJson;
        this.rowData = this.data;
        for (let val of this.rowData) {
          val.isReadOnly = this.setReadOnly;
        }
      },
      error => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
  refresh() {
    this.getRemarksHistoryList();
  }
  closePanel(e) {
    this.getRemarksHistoryList();
  }
}
